<template>
    <el-dialog
            title="详情"
            :visible="true"
            :append-to-body=true
            width="800px"
            :before-close="handleClose">
        <el-row>
            <el-col :span="11">
                <div class="grid-content bg-purple">
                    基础信息
                </div>
                <div class="content">
                    <div class="label">
                        <span class="fl">标签类型：</span><span class="fr">{{data.code_name}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">物流码：</span><span class="fr">{{data.logistics_code}}</span>
                    </div>
                    <div class="label">
                    <span  class="fl">生产批次号：</span><span class="fr">{{data.production_batch}}</span>
                </div>
                    <div class="label">
                        <span  class="fl">发货单号：</span><span class="fr">{{data.stock_out_sn}}</span>
                    </div>
                    <div class="label">
                        <span  class="fl">发货时间：</span><span class="fr">{{data.stock_out_time}}</span>
                    </div>
                    <div class="label" v-if="data.source_type !== 1">
                        <span class="fl">退货单号：</span><span class="fr">{{data.return_goods_sn}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">产品编号：</span><span class="fr">{{data.product_sn}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">产品名称：</span><span class="fr">{{data.product_name}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">产品条码：</span><span class="fr">{{data.product_bar_code}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">单位：</span><span class="fr">{{data.product_unit}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">生产日期：</span><span class="fr">{{data.production_date}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">有效期至：</span>
                        <span class="fr">{{data.expiring_date}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">来源：</span>
                        <span class="fr" v-if="data.source_type == 0">未知</span>
                        <span class="fr" v-if="data.source_type == 1">扫码</span>
                        <span class="fr" v-if="data.source_type == 2">退货</span>
                    </div>
                    <div class="label">
                        <span class="fl">记录时间：</span><span class="fr">{{data.created_at}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="2" class="grid-content bg-purple-light"></el-col>
            <el-col :span="11"><div class="grid-content bg-purple">
                窜货信息
            </div>
                <div class="content">
                    <div class="label">
                        <span class="fl">窜货数量：</span><span class="fr">{{data.real_return_goods_num}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">窜货经销商编号：</span><span class="fr">{{data.from_sn}}</span>
                    </div>
                    <div class="label">
                        <span  class="fl">窜货经销商名称：</span><span class="fr">{{data.from_name}}</span>
                    </div>
                    <div class="label">
                        <span  class="fl">销售区域：</span><span class="fr">{{data.from_region}}</span>
                    </div>
                    <div class="label">
                        <span  class="fl">窜货地点：</span><span class="fr">{{data.from_address}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">被窜货经销商编号：</span><span class="fr">{{data.feeling_sn}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">被窜货经销商名称：</span><span class="fr">{{data.feeling_name}}</span>
                    </div>
                    <div class="label">
                        <span class="fl">备注：</span><span class="fr">{{data.remarks}}</span>
                    </div>
                </div>
            </el-col>
        </el-row>

    </el-dialog>
</template>

<script>
    export default {
        name: "dealerDetail",
        data(){
            return {
                data: {
                },

            }
        },
        props:{
            detailData:{
                type:String,
                default:''
            }
        },
        methods:{
            getInfo(){
                let url = '/feelinggoods/' + this.detailData;
                this.$get('logistics', url, {
                    logistics:this.detailData
                }).then(res => {
                    //console.log(res);
                    this.data = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            handleClose(){
                this.$emit('handleClose');
            },
        },
        created(){
            this.getInfo();
        }
    }
</script>

<style lang="scss" scoped>

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        line-height: 36px;
        padding-left: 10px;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .content{
        min-height: 200px;
        .label{
            height: 40px;
            margin: 0 30px;
            .fr{
                float: right;
                display: block;
                width: 120px;
                text-align: left;
                margin: 6px 0;
            }
            .fl{
                float: left;
                display: block;
                width: 130px;
                text-align: right;
                margin: 6px 0;
                overflow: hidden;
            }
        }

    }


</style>